// libs
import React from 'react';

import { cn } from '@lyearn/style';
// components
import { Typography } from '@lyearn/ui';

// content
import { useLearningContent } from '../context';
// types
import { NameProps } from '../types';

function Name({ className, variant, ...rest }: NameProps) {
  const { content } = useLearningContent();

  if (!content.name) {
    return null;
  }

  return (
    <Typography
      className={cn('text-text-primary', className)}
      title={content.name}
      variant={variant ?? 'body-long-01'}
      {...rest}>
      {content.name}
    </Typography>
  );
}

export default React.memo(Name);
